module.exports = __webpack_public_path__ + "static/img/blue_04_370.bfb8933.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/blue_04_370.png
// module id = yWaq
// module chunks = 0